import { render, staticRenderFns } from "./JumpLinks.vue?vue&type=template&id=54b494b2&scoped=true&"
import script from "./JumpLinks.vue?vue&type=script&lang=js&"
export * from "./JumpLinks.vue?vue&type=script&lang=js&"
import style0 from "./JumpLinks.vue?vue&type=style&index=0&id=54b494b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b494b2",
  null
  
)

export default component.exports